<footer class="app-footer">
  <div class="footer-container">
    <div class="footer-left">
      <span class="copyright">
        © {{ currentYear }} <strong>Enterprise SMS</strong> by Tecknovate
      </span>
    </div>
  </div>
</footer>
